import * as ko from "knockout";
import { ChangeMasterDataViewModel } from "../ViewModels/ChangeMasterDataViewModel";

export class ChangeMasterData {
    changeMasterDataViewModel: ChangeMasterDataViewModel;
    $changeMasterDataModal: JQuery;

    constructor() {
        this.changeMasterDataViewModel = new ChangeMasterDataViewModel();
        this.$changeMasterDataModal = $("#changeMasterDataModal");
        if (this.$changeMasterDataModal[0]) {
            ko.applyBindings(this.changeMasterDataViewModel, this.$changeMasterDataModal[0]);
        }
    }

    init(): void {
        this.changeMasterDataViewModel.init();
    }
}